import type { Pagination } from '@shared/models';

export interface ClientListResponse {
    status:      boolean;
    client_list: ClientResponse[];
    pagination:  Pagination;
}

export interface ClientResponse {
    id:          number;
    fullname:    string;
    email:       string;
    profile:     string;
    commerce:    string;
    institution: string;
    status:      string;
}
